var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{on:{"click":function($event){_vm.videoVisible = true}}},[_vm._v(" 查看视频 ")]),_c('VideoDrawer',{attrs:{"title":_vm.lessonName,"visible":_vm.videoVisible,"ai-lesson-id":_vm.aiLessonId,"lesson-id":_vm.lessonId,"class-type-id":_vm.classTypeId},on:{"update:visible":function($event){_vm.videoVisible=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }